import { Component, Fragment } from 'react';
import { rm } from 'utils';
import { Field, resetSection } from 'redux-form';
import * as rules from 'views/CheckoutPage/validation';
import { RenderLabeledInput } from 'components/Shared/Form/inputs';
import connect from 'components/Shared/connect';
import { fieldStreetAlternate, fieldZipcodeAlternate } from 'views/CheckoutPage/selector';
import cn from 'classnames';
import ManualFormWrapper, { RenderFormProps } from './manualForm';
import { postAddressSuggestions, postZipcodeSuggestions } from 'services/ApiCheckoutPageService';
import SuggestionField, { addressFormat, zipFormat, zipParser } from './suggestionField';
import commonStyles from './styles.scss';
import styles from './deliveryForm.scss';
import { DisclaimerInfo } from 'views/CheckoutPage/ContactInfo/themes/BGH-RD3/disclaimerInfo';
import { CustomerType } from 'models/CustomerType';

const renderForm = (props: RenderFormProps) => {
  const onAddressChange = (street: string) => {
    props.resetAddressValidation();
    return postAddressSuggestions(street);
  };
  const onZipCodeChange = (zipCode: string) => {
    props.resetAddressValidation();
    return postZipcodeSuggestions(zipCode);
  };

  const isCompanyMode = props.customerType === CustomerType.Company;

  return (
    <Fragment>
      <h2 className={styles.title}>{rm('checkout_contact_info_delivery_headline')}</h2>
      <div>
        {isCompanyMode && (
          <Field
            validate={[rules.name, rules.deliveryNameLength(props.maxNameLength)]}
            name="deliveryAddress.lastName"
            className={commonStyles.input}
            component={RenderLabeledInput}
            props={{ customLabel: rm('checkout_companyname') }}
            onBlur={props.onBlur}
          />
        )}
        {!isCompanyMode && (
          <Fragment>
            <Field
              validate={[rules.name, rules.deliveryNameLength(props.maxNameLength)]}
              name="deliveryAddress.firstName"
              className={cn(commonStyles.input, commonStyles.left)}
              component={RenderLabeledInput}
              props={{ customLabel: rm('checkout_firstname') }}
              onBlur={props.onBlur}
            />
            <Field
              validate={[rules.name, rules.deliveryNameLength(props.maxNameLength)]}
              name="deliveryAddress.lastName"
              className={cn(commonStyles.input, commonStyles.right)}
              component={RenderLabeledInput}
              props={{ customLabel: rm('checkout_lastname') }}
              onBlur={props.onBlur}
            />
          </Fragment>
        )}

        <SuggestionField
          name="deliveryAddress.street"
          className={commonStyles.input}
          validate={rules.address}
          label={rm('checkout_address')}
          onBlur={props.onBlur}
          onChange={onAddressChange}
          onSelect={props.suggestionSelected(fieldStreetAlternate)}
          format={addressFormat}
          props={{ customValid: props.hasValidAddress }}
        />
        <SuggestionField
          name="deliveryAddress.zipCode"
          className={cn(commonStyles.input, commonStyles.left)}
          validate={rules.zip}
          label={rm('checkout_zipcode')}
          onBlur={props.onBlur}
          onChange={onZipCodeChange}
          onSelect={props.suggestionSelected(fieldZipcodeAlternate)}
          format={zipFormat}
          props={{
            inputMode: 'numeric',
            customValid: props.hasValidAddress || props.hasValidZipCode
          }}
          parse={zipParser}
        />
        <Field
          className={cn(commonStyles.input, commonStyles.right)}
          validate={rules.city}
          name="deliveryAddress.city"
          component={RenderLabeledInput}
          onBlur={props.onBlur}
          props={{
            customLabel: rm('checkout_city'),
            customValid: props.hasValidAddress || props.hasValidZipCode
          }}
        />

        <DisclaimerInfo className={styles.disclaimer} />
      </div>
    </Fragment>
  );
};

interface DeliveryFormProps {
  resetDelivery: () => void;
  maxNameLength: number;
}

class DeliveryForm extends Component<DeliveryFormProps> {
  public componentWillUnmount() {
    this.props.resetDelivery();
  }
  public render(): JSX.Element {
    return <ManualFormWrapper formType="delivery" renderForm={renderForm} />;
  }
}

export default connect<DeliveryFormProps>(undefined, dispatch => ({
  resetDelivery: () => dispatch(resetSection('checkout', 'address.deliveryAddress'))
}))(DeliveryForm);
